import { FeederService } from '.././../services/feeder.service';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as _ from 'lodash';
import { CustomDateComponent } from '../../reports/customdate/custom-date.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-feeder-reports',
  templateUrl: './feeder-reports.component.html',
  styleUrls: ['./feeder-reports.component.scss']
})
export class FeederReportsComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  selectedFeeder: any;
  displayedFeeder: any;
  feederOptions: any = [];
  displayedOptions = [];
  displayedColumns = [];
  selectedDuration: any;
  timeOptions: any = [];
  feederAlertData: any;
  gatewayData = [];
  dataSource ;
  date = {startDate: '', endDate: ''};
  isAlertData: boolean = true;
  isGatewayData: boolean = true;
  isAlertTable: boolean;
  isGatewayTable: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private feederService: FeederService, private matDialog: MatDialog, private ngxLoader: NgxUiLoaderService) { }

  ngOnInit() {
    console.log("THE DATA", this.data);
    this.displayedOptions = [];
    this.feederOptions = [];
    this.selectedFeeder = this.data.selectedFeeder;
    this.feederOptions = this.data.feederOptions;
    this.displayedOptions = this.data.displayedOptions;
    this.displayedFeeder = this.data.displayedFeeder;
    this.selectedDuration = this.data.selectedDuration;
    this.timeOptions = this.data.timeOptions;
    this.date.startDate = this.data.startDate;
    this.date.endDate = this.data.endDate;

    if(this.data.type.toLowerCase() == 'alert'){
      this.isAlertTable = true;
      this.isGatewayTable = false;
      this.getAlertReportData(this.selectedFeeder, this.selectedDuration);
    } else if (this.data.type.toLowerCase() == 'gateway'){
      this.isAlertTable = false;
      this.isGatewayTable = true;
      this.getGatewayReportData(this.selectedFeeder, this.selectedDuration)
    }
  }

  getAlertReportData(feederID, time){
    this.ngxLoader.startLoader('alert');
    if(time.toLowerCase() == 'custom'){
      this.feederService.getAlertFeederReport({"feederID": feederID, "duration": {"type": time, "startDate":this.date.startDate, "endDate":this.date.endDate}}).subscribe((response:any) => {
        if(response.code=="-1"){
          console.log("ERROR IN QUERY: ", response.error);
        } else if(response.data.length == 0){
          console.log("NO DATA FOUND");
          this.isAlertData = false;
        } else if(response.data.length > 0) {
          this.isAlertData = true;
          this.feederAlertData = response.data;
          this.feederAlertData.forEach(alert => {
            // Convert the ISO date string to a Date object
            const dateObj = new Date(alert.date);
          
            // Extract the date and time components
            alert.dateFormat = dateObj.toISOString().split('T')[0];
            const hours = dateObj.getHours().toString().padStart(2, '0');
            const minutes = dateObj.getMinutes().toString().padStart(2, '0');
            alert.time = `${hours}:${minutes}`;
            delete alert.date;
          });
          this.feederAlertData = this.feederAlertData.reverse();
          console.log("ALERT REPORT >>>>>", this.feederAlertData);
        }
        this.ngxLoader.stopLoader('alert');
      });
    } else{
      this.feederService.getAlertFeederReport({"feederID": feederID, "duration": {"type": time}}).subscribe((response:any) => {
        if(response.code=="-1"){
          console.log("ERROR IN QUERY: ", response.error);
        } else if(response.data.length == 0){
          console.log("NO DATA FOUND");
          this.isAlertData = false;
        } else if(response.data.length > 0) {
          this.isAlertData = true;
          this.feederAlertData = response.data;
          this.feederAlertData.forEach(alert => {
            // Convert the ISO date string to a Date object
            const dateObj = new Date(alert.date);
          
            // Extract the date and time components
            alert.dateFormat = dateObj.toISOString().split('T')[0];
            const hours = dateObj.getHours().toString().padStart(2, '0');
            const minutes = dateObj.getMinutes().toString().padStart(2, '0');
            alert.time = `${hours}:${minutes}`;
            delete alert.date;
          });
          this.feederAlertData = this.feederAlertData.reverse();
          console.log("ALERT REPORT >>>>>", this.feederAlertData);
        }
        this.ngxLoader.stopLoader('alert');
      });
    }
  }

  getGatewayReportData(feederID, time){
    this.ngxLoader.startLoader("gateway");
    this.gatewayData = [];
    console.log("IN GATEWAY")
    if(time.toLowerCase() == 'custom'){
      this.feederService.getFeederData({"feederid": feederID,"duration":{"type":time, "startDate": this.date.startDate, "endDate": this.date.endDate}}).subscribe((response:any) => {
        console.log("RESPONSE FOR GATEWAY ", response);
        if(response.code == '-1'){
          this.dataSource =[];
          console.log("ERROR IN QUERY: ", response.error);
          this.isGatewayData = false;
        } else if(response.data.length == 0){
          this.dataSource =[];
          console.log("NO DATA FOUND");
          this.isGatewayData = false;
        } else if(response.data.length > 0){
          this.isGatewayData = true;
          response.data.forEach(element => {
            var [date, time] = element.DATE.split(' ');
            time = time.slice(0,5);
            this.gatewayData.push({'switchID': element.switchGearID,'date': date,'time':time ,'data':JSON.parse(element.readings) });
          });
          this.gatewayData.reverse();
          console.log("DATASOURCE", this.gatewayData);
          this.dataSource.data = this.gatewayData;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;

          this.generateDisplayedColumns();
        } else {
          this.dataSource =[];
        }
        //this.ngxLoader.startLoader("gateway");
      });
    } else {
      this.feederService.getFeederData({"feederid": feederID,"duration":{"type":time}}).subscribe((response: any) => {
        console.log("RESPONSE FOR GATEWAY ", response);
        if(response.code == '-1'){
          this.dataSource =[];
          console.log("ERROR IN QUERY: ", response.error);
          this.isGatewayData = false;
          //this.ngxLoader.startLoader("gateway");
        } else if(response.data.length == 0){
          this.dataSource =[];
          console.log("NO DATA FOUND");
          this.isGatewayData = false;
          //this.ngxLoader.startLoader("gateway");
        } else if(response.data.length > 0){
          this.isGatewayData = true;
          response.data.forEach(element => {
            var [date, time] = element.DATE.split(' ');
            time = time.slice(0,5);
            this.gatewayData.push({'feederID': element.feederID,'date': date,'time':time ,'data':JSON.parse(element.readings) });
          });
          this.gatewayData.reverse();
          this.generateDisplayedColumns();
          console.log("DATASOURCE", this.gatewayData);
          this.dataSource = new MatTableDataSource(this.gatewayData)
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;

          
          //this.ngxLoader.startLoader("gateway");
        }else {
          this.dataSource =[];
        }
        this.ngxLoader.stopLoader("gateway");
      });
    }
  }

  generateDisplayedColumns(){
    if (this.gatewayData.length > 0) {
      // Get all keys from the first element
      const keys = Object.keys(this.gatewayData[0]);

      // Extract keys from nested 'data' objects
      const nestedKeys = Object.keys(this.gatewayData[0].data);

      // Combine the keys and nested keys without using spread operator
      this.displayedColumns = keys.concat(nestedKeys);

      // Remove the 'data' key to avoid duplicate column
      this.displayedColumns = this.displayedColumns.filter(column => column !== 'data');

      console.log("DISPLAYED COLUMNS>>>>", this.displayedColumns)
    }
  }

  changeFeeder(feederID){
    feederID = _.cloneDeep(feederID).split('[')[0];
    this.selectedFeeder = feederID;
    this.getAlertReportData(feederID, this.selectedDuration);
  }

  changeDate(time){
    if(time.toLowerCase() == 'custom'){
      let dialogRef = this.matDialog.open(CustomDateComponent, {
        autoFocus: false,
        height: '350px', width: '450px'
      });
      dialogRef.afterClosed().subscribe(value => {
        console.log('value =====>', value);
        this.date.startDate = value.startDate;
        this.date.endDate = value.endDate;
        console.log("date after dialog>>>>>", this.date);
        this.getAlertReportData(this.selectedFeeder, time);
      });
    } else {
      this.selectedDuration = time;
      this.getAlertReportData(this.selectedFeeder, time);
    }
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  changeGatewayDate(time){
    if(time.toLowerCase() == 'custom'){
      //DO CUSTOM POP-UP + call data service.
      const dialogConfig = new MatDialogConfig();
      let dialogRef = this.matDialog.open(CustomDateComponent, {
        autoFocus: false,
        height: '350px', width: '450px'
      });
      dialogRef.afterClosed().subscribe(value => {
        console.log('value =====>', value);
        this.date.startDate = value.startDate;
        this.date.endDate = value.endDate;
        console.log("date after dialog>>>>>", this.date);
        //CALL API
        this.getGatewayReportData(this.selectedFeeder, time);
      });
    } else {
      this.selectedDuration = time;
      this.changeGatewayFeeder(this.selectedFeeder)
    }
  }

  changeGatewayFeeder(feederID){
    feederID = _.cloneDeep(feederID).split('[')[0];
    this.selectedFeeder = feederID;
    this.getGatewayReportData(feederID, this.selectedDuration);
  }

}
